import { render, staticRenderFns } from "./PackageDescriptorList.vue?vue&type=template&id=4b3e459e&"
import script from "./PackageDescriptorList.vue?vue&type=script&lang=js&"
export * from "./PackageDescriptorList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports